import React, { FC } from 'react';
import { Icon } from '@src/atoms/Icon';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';
import { Portal } from '@src/core/Portal';
import styles from './CarouselArrow.scss';
import { IDefaultComponentProps } from '@src/models/props';

interface ICarouselArrowProps extends IDefaultComponentProps {
  /** Направление стрелки */
  type?: 'right' | 'left';

  /**
   * Будет ли обернуто в `<Portal>`,
   * чаще всего нужно для того, чтобы разместить стрелку в произвольном месте
   * В противном случае внутренний `overflow: hidden` будет мешать такому размещению
   * */
  withPortal?: boolean;

  /** Показывать стрелку */
  isHidden: boolean;

  /** Дейстие при нажатии на стрелку */
  onClick: () => void;
}

const CarouselArrowComponent: FC<ICarouselArrowProps> = ({
  type = 'left',
  onClick,
  isHidden,
  className,
  style,
  ...rest
}) => {
  const classes = classnames(styles.root, {
    [styles.hidden]: isHidden,
  });

  const wrapperClasses = classnames(styles.wrapper, className, ...getClasses(styles, { wrapper: type }));

  return (
    <div className={wrapperClasses} style={style} onClick={onClick} {...rest}>
      <button className={classes}>
        <Icon name="outlineLeft" />
      </button>
    </div>
  );
};

/** Компонент стилизованной стрелки */
export const CarouselArrow: FC<ICarouselArrowProps> = (props) => {
  if (props.withPortal) {
    <Portal>
      <CarouselArrowComponent {...props} />
    </Portal>;
  }

  return <CarouselArrowComponent {...props} />;
};
